import { render, staticRenderFns } from "./screenModel.vue?vue&type=template&id=4c970047&scoped=true"
import script from "./screenModel.vue?vue&type=script&lang=js"
export * from "./screenModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c970047",
  null
  
)

export default component.exports